import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../../Components/ProtectedRoute";
import AusbildungInterestsPage from "./AusbildungInterestsPage";
import AusbildungSubmissionsPage from "./AusbildungSubmissionsPage";
import AusbildungEnglishBoundary from "./AusbildungEnglishBoundary";
import AusbildungRoomsPage from "./AusbildungRoomsPage";

const AusbildungRoutes = (roleName, roleNames) => {
  const roles = roleNames || [roleName];
  const allowedRoles = ["AUSBILDUNG_MANAGER", "ADMIN", "ADMIN_DEVELOPER"];
  return <>
    <Route path="/dashboard/ausbildung/submissions" element={
      <AusbildungEnglishBoundary>
        <ProtectedRoute element={<AusbildungSubmissionsPage />} allowedRoles={allowedRoles} userRoles={roles} />
      </AusbildungEnglishBoundary>
    } />
    <Route path="/dashboard/ausbildung/interests" element={
      <AusbildungEnglishBoundary>
        <ProtectedRoute element={<AusbildungInterestsPage />} allowedRoles={allowedRoles} userRoles={roles} />
      </AusbildungEnglishBoundary>
    } />
    <Route path="/dashboard/ausbildung/rooms" element={
      <AusbildungEnglishBoundary>
        <ProtectedRoute element={<AusbildungRoomsPage />} allowedRoles={allowedRoles} userRoles={roles} />
      </AusbildungEnglishBoundary>
    } />
    <Route path="/dashboard/ausbildung/rooms/:categoryKey" element={
      <AusbildungEnglishBoundary>
        <ProtectedRoute element={<AusbildungRoomsPage />} allowedRoles={allowedRoles} userRoles={roles} />
      </AusbildungEnglishBoundary>
    } />
  </>;
};

export default AusbildungRoutes;
